module.exports = __webpack_public_path__ + "img/menu_icon_user_notice_off.f8b5a6f.svg";